export function phoneMask (numero) {
  if (typeof numero !== 'string' || numero.length !== 9 || isNaN(Number(numero))) {
    // Verificar si el número no es una cadena de 9 dígitos
    console.log('El número no es válido. Debe ser una cadena de 9 dígitos.')
    return null
  }

  return numero.replace(/(\d{2})(\d{3})(\d{2})(\d{2})/, '$1 $2 $3 $4')
}
